import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";
import { ECO_URLS, trackEcoClick } from "../lib/ecoTrack";
import "./Footer.css";

/**
 * Футер: навигация, ссылка на экосистему Майнкрафтия, юр.инфо.
 * Юр.лицо — ИП Иванкова В.С. (как на minecraftia-school.ru / marfusha.su).
 */
export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="rb-footer">
      <div className="rb-container rb-footer__inner">
        <div className="rb-footer__col rb-footer__col--brand">
          <div className="rb-footer__brand">
            <img src={logo} alt="Рублокс" />
            <span>Рублокс</span>
          </div>
          <p className="rb-footer__tagline">
            Игровая платформа экосистемы онлайн-школы «Майнкрафтия».
            Играй и создавай 3D-игры бесплатно.
          </p>
        </div>

        <div className="rb-footer__col">
          <h4>Платформа</h4>
          <Link to="/">Главная</Link>
          <Link to="/download">Скачать приложение</Link>
          <a href="/#editor">Редактор игр</a>
          <a href="/#diamonds">Алмазы</a>
        </div>

        <div className="rb-footer__col">
          <h4>Экосистема</h4>
          <a
            href={ECO_URLS.minecraftia}
            target="_blank"
            rel="noreferrer"
            data-mtrk-click="eco:minecraftia:footer"
            onClick={() => trackEcoClick("minecraftia", "footer")}
          >
            Онлайн-школа «Майнкрафтия»
          </a>
          <a
            href={ECO_URLS.maska}
            target="_blank"
            rel="noreferrer"
            data-mtrk-click="eco:maska:footer"
            onClick={() => trackEcoClick("maska", "footer")}
          >
            Соцсеть «Маська»
          </a>
          <a href="/#about">Об авторе</a>
        </div>

        <div className="rb-footer__col">
          <h4>Аккаунт</h4>
          <Link to="/login">Войти</Link>
          <Link to="/signup">Регистрация</Link>
          <Link to="/terms">Пользовательское соглашение</Link>
          <Link to="/privacy-policy">Политика конфиденциальности</Link>
        </div>
      </div>

      <div className="rb-footer__legal">
        <div className="rb-container">
          <p>
            ИП Иванкова Виктория Сергеевна · ОГРНИП 322237500039230 · ИНН
            233507286445
          </p>
          <p>© {year} Рублокс. Все права защищены.</p>
        </div>
      </div>
    </footer>
  );
}
